import React from 'react';
import { render } from 'react-dom';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import { ApolloProvider } from 'react-apollo';
import { PersistGate } from 'redux-persist/integration/react';
import { client } from './apollo';
import { store, persistor, history } from './store';
import './bulma.min.css';
import './normalize.min.css';
import './index.css';
import './noty.min.css';
import './bulma-checkradio.min.css';
import App from './containers/App';
import * as serviceWorker from './serviceWorker';

render(
  <Provider store={store}>
    <ApolloProvider client={client}>
      <PersistGate loading={null} persistor={persistor}>
        <ConnectedRouter history={history}>
          <App />
        </ConnectedRouter>
      </PersistGate>
    </ApolloProvider>
  </Provider>,
  document.getElementById('root'));

serviceWorker.unregister();
